import React from "react";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";

export default function FooterCard13() {
  return (<>
    <footer className="food-footer-fc-13">
   
      <div className="footer-fc-13-container">
        {/* LEFT BLOCK */}
        <div className="footer-fc-13-left">   <div className="footer-fc-13-wave"></div>

          <h1 className="footer-fc-13-logo">FOOD <span>Farm Theme</span></h1>

          <div className="footer-fc-13-info">
            <p>200k Camden Borough, 2nd London,<br />United Kingdom</p>

            <p className="footer-fc-13-phone">+123 456 7890</p>
            <p className="footer-fc-13-mail">Support@mail.com</p>
          </div>
        </div>

        {/* RIGHT BLOCK */}
        <div className="footer-fc-13-right"><div className="social-fc-13-row">
                               <div className="social-fc-13-icons"><h3 >MY SOCIAL PROFILE</h3></div> 
                               <div className="social-fc-13-icons">
                                 <span><FaFacebookF />
                                           </span>
                                 <span>  <FaTwitter />
                                          </span>
                                 <span>   <FaInstagram />
                                             </span>
                                 <span><FaLinkedinIn />
                                            </span>
                               </div>
                             </div> 
                              <p className="footer-fc-13-bottom-text">
            Food Farm WordPress Theme 2020 Design & Developed by VW Themes
          </p>
        </div>
      </div>
    </footer>
    <style>{`.food-footer-fc-13 {
  position: relative;
  background: #000;
  background-size: cover;
  background-position: center;
overflow:hidden;margin-top:50px;
  color: white;
}

/* SOCIAL ICONS */
.social-fc-13-row {
  margin-top: 20px;
}
.social-fc-13-icons {display:flex;justify-content:center;}

.social-fc-13-icons span {
  background: rgba(144, 202, 249,1); margin-top: 20px;display:flex;justify-content:center;align-items:center;
  color: #000;
  width:40px;height:40px;
  margin-right: 8px;
  border-radius: 4px;
  cursor: pointer;
}
/* Curved top wave */
.footer-fc-13-wave {
  position: absolute;
  top: -5px;
  left: 0;
  width: 240px;left:-5px;
  height: 30px;
  background: white;
  border-bottom-left-radius: 50% 100%;
  border-bottom-right-radius: 50% 100%;
}

/* Content layout */
.footer-fc-13-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  max-width: 1100px;
  margin: auto;
  gap: 80px;
}
.footer-fc-13-left{padding:15px;position:relative;width:200px;height:400px;background:#222222}

.footer-fc-13-right {  padding-top: 120px;
  padding-bottom: 50px;
  flex: 1;
}

/* Logo */
.footer-fc-13-logo {
  font-size: 42px;
  font-weight: 800;
  margin-bottom: 20px;
}

.footer-fc-13-logo span {
  display: block;
  font-size: 16px;
  font-weight: 300;
  margin-top: 4px;
}

/* Info */
.footer-fc-13-info {
  margin-top: 20px;
  line-height: 1.6;
  font-size: 16px;
}

/* Buttons */
.buy-btn-fc-13 {
  background: rgba(144, 202, 249,1);
  color: white;
  border: none;
  padding: 10px 16px;
  font-size: 14px;
  border-radius: 26px;
  cursor: pointer;
  margin-top: 25px;
}

.buy-btn-fc-13:hover {
  background: rgba(144, 202, 249,1);
}

/* Right Section */
.footer-fc-13-title {
  font-size: 32px;
  font-weight: 700;
}

.footer-fc-13-bottom-text {
  margin-top: 50px;
  font-size: 14px;
  opacity: 0.8;
  text-align: center;
}
`}</style>
    </>
  );
}
